import React from 'react';
import { useSelector } from 'react-redux';
import { getShowConfirmationPage } from '../../../selectors/tools';
import DTCancelAmazonOrderAndSendMacroNode from '../NodeGroups/DTCopyTextSendMacro/DTCancelAmazonOrderAndSendMacroNode/DTCancelAmazonOrderAndSendMacroNode';

const CancelAmazonOrderAndSendMacro = () => {
  const showConfirmationPage = useSelector(getShowConfirmationPage);

  return (
    <DTCancelAmazonOrderAndSendMacroNode
      showConfirmation={showConfirmationPage}
      message={'The order has been scheduled for a refund.'}
    />
  );
};

export default CancelAmazonOrderAndSendMacro;
